import type { NetworkConfig } from "@voxmedia/duet-context/context/config-context";
import { getDomainApex } from "@voxmedia/duet-utils/url";

import { APP_NAME } from "./commonjs";

export { APP_NAME } from "./commonjs";

if (!process.env.NEXT_PUBLIC_NETWORK_NAME) {
  throw new Error("NEXT_PUBLIC_NETWORK_NAME env variable is required");
}

export const ORGANIZATION_ID = 1;
export const NETWORK_ID = Number(process.env.NEXT_PUBLIC_NETWORK_ID);
export const NETWORK_NAME: string = process.env.NEXT_PUBLIC_NETWORK_NAME;
export const CONCERT_ADS_NETWORK: string =
  process.env.NEXT_PUBLIC_CONCERT_ADS_NETWORK || "";
export const SAILTHRU_ID = process.env.NEXT_PUBLIC_SAILTHRU_ID;
export const AFFILIATE_SUBTAGS_SITE_KEY = String(
  process.env.NEXT_PUBLIC_AFFILIATE_SUBTAGS_SITE_KEY,
);
export const AFFILIATE_PROVIDERS_CJ_ID = String(
  process.env.NEXT_PUBLIC_AFFILIATE_PROVIDERS_CJ_ID,
);
export const NETWORK_APEX_DOMAIN = getDomainApex(
  process.env.NEXT_PUBLIC_NETWORK_DOMAIN || "",
);

// List of entitlements offered by the network
export const NETWORK_ENTITLEMENTS: string[] = (
  process.env.ENTITLEMENTS?.split(",") || []
).filter(Boolean);

export const AFFILIATE_NCA_PARTICIPANT =
  process.env.NEXT_PUBLIC_AFFILIATE_NCA_PARTICIPANT === "true";

// Config used for Config/UI Context
export const networkConfig: NetworkConfig = {
  affiliateSubtagsSiteKey: AFFILIATE_SUBTAGS_SITE_KEY,
  affiliateNCAParticipant: AFFILIATE_NCA_PARTICIPANT,
  appName: APP_NAME,
  networkId: NETWORK_ID,
  networkName: NETWORK_NAME,
  organizationId: ORGANIZATION_ID,
  concertAds: {
    network: CONCERT_ADS_NETWORK,
    gam: "172968584",
  },
};

// All public profile are hosted the primary site's domain (i.e. sbnation.com)
let networkPublicProfilesHost = "";
if (process.env.NEXT_PUBLIC_DEPLOY_ENV === "production") {
  networkPublicProfilesHost = `https://${NETWORK_APEX_DOMAIN}`;
} else if (process.env.NEXT_PUBLIC_DEPLOY_ENV === "pre-production") {
  networkPublicProfilesHost = `https://production.${NETWORK_APEX_DOMAIN}`;
} else {
  networkPublicProfilesHost = `https://staging.${NETWORK_APEX_DOMAIN}`;
}

export const NETWORK_PUBLIC_PROFILES_HOST = networkPublicProfilesHost;
